import { getProtonConfig } from '@proton/shared/lib/interfaces/config';

export default getProtonConfig();
